import { Component, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'pds-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() classString: Array<string>;
  @Input() isDisabled: boolean = false;
  @ContentChild('iconLeft',{static: false}) iconLeftTemplateRef: TemplateRef<any>;
  @ContentChild('iconRight',{static: false}) iconRightTemplateRef: TemplateRef<any>;

  public bemClassName = "";

  constructor() { }

  ngOnChanges(){
    this.bemClassName = this.classString.reduce((acc, currentValue) => {
      return `${acc} pds-btn--${currentValue}`
    }, "")
  }

  ngOnInit(): void {
  }

}
